var map = {
	"./ru": [
		54963,
		963
	],
	"./ru.js": [
		54963,
		963
	],
	"./uk": [
		21230,
		230
	],
	"./uk.js": [
		21230,
		230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 972;
module.exports = webpackAsyncContext;